<template>
    <div class="relative-article">
        <el-row>
            <el-col :span="6">
                <span>推广位名称：</span>
                <el-input v-model="artName" style="width: 150px;" placeholder="请输入推广位名称" clearable></el-input>
            </el-col>
            <el-col :span="8" :offset="1">
                <span>推广位分类：</span>
                <el-select v-model="spreadType" placeholder="请选择分类">
                    <el-option v-for="item in spreadSpaceType" :key="item.value" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="5">
                <span>备注：</span>
                <el-input v-model="remark" style="width: 150px;" placeholder="请输入备注" clearable></el-input>
            </el-col>
            <el-col :span="4">
                <div class="box box-align-center box-pack-end mt-btns">
                    <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
                </div>
            </el-col>
        </el-row>
        <div class="mt12 conmmon-table">
            <dy-table :columns="columns" :table-data="tableData" ref="multipleTable" v-loading="tableLoading"
                :total="total" :page-num="currentPage" :page-size="10" @current-change="onCurrentChange"
                @selection-change="onSelectionChange" element-loading-text="加载中"></dy-table>
            <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px">
                <el-button type="primary" plain @click="saveData">保存</el-button>
                <el-button type="danger" plain @click="closeDialog">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'
import { spreadSpaceList } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { spreadSpaceType } from '@/utils/commonData';
import { subtractArrays, uniqueBy } from '@/utils/utils';

var that = null;
export default {
    name: 'courseCommon',
    components: {
        DyTable
    },
    props: {
        list: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            artName: null,
            categoryId: '',
            tableLoading: true,
            currentPage: 1,
            options: [],
            columns: [
                {
                    type: "selection",
                    width: "55"
                },
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'id',
                    title: '推广位ID'
                },
                {
                    key: 'name',
                    title: '推广位名称'
                },
                {
                    key: 'remark',
                    title: '备注'
                },
                {
                    key: 'spreadSpaceTypeTxt',
                    title: '推广位分类'
                },
            ],
            pageSize: 10,
            tableData: [],
            total: 0,

            spreadSpaceType,
            spreadType: null,
            delData: [],//删除的数据id
            isChange: false,

            remark: '',
            resultList: []
        }
    },
    watch: {
        list(val) {
            that.resultList = val;
            that.setPage();
        }
    },
    created() {
        that = this;
        that.resultList = that.list;
        that.getList();
    },
    methods: {
        // 重置
        resetList() {
            that.artName = null;
            that.remark = null;
            that.spreadType = null;
            that.currentPage = 1;
            that.getList();
        },
        // 关闭弹窗
        closeDialog() {
            that.$emit('close-dialog');
        },
        onSelectionChange(val) {
            if (that.isChange || val.length == 0) {
                return;
            }
            that.delData = subtractArrays(that.tableData, val);
            let allArr = uniqueBy(that.tableData.concat(that.resultList), 'id');
            that.resultList = subtractArrays(allArr, that.delData);
        },
        saveData() {
            that.$emit('save-data', that.resultList);
            that.$emit('close-dialog');
        },
        onCurrentChange(val) {
            console.log(val);
            that.isChange = true;
            that.currentPage = val;
            that.getList();
        },
        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    } else {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    }
                }
            } else {
                return;
            }
            return children;
        },
        setPage() {
            // 重新设置选中状态
            that.$nextTick(() => {
                let selList = [];
                console.log('当前选择数据', that.resultList);
                that.$refs.multipleTable.$refs.ElTable.clearSelection();
                that.resultList.forEach((item) => {
                    const row = that.tableData.find((row) => row.id === item.id);
                    if (row) {
                        selList.push(row);
                        that.$refs.multipleTable.$refs.ElTable.toggleRowSelection(row, true);
                    }
                });
                that.delData = subtractArrays(that.tableData, selList);
                that.$nextTick(() => {
                    that.isChange = false;
                })
            })
        },
        //获取推广位列表
        getList() {
            let info = {
                name: that.artName,
                remark: that.remark,
                spreadSpaceType: that.spreadType,
                page: that.currentPage,
                pageSize: that.pageSize,
                needPage: true
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            spreadSpaceList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('推广位列表', ress);
                    that.tableLoading = false;
                    that.total = ress.total;
                    that.tableData = ress.list.map(item => {
                        let txt = spreadSpaceType.find(obj=>obj.value == item.spreadSpaceType);
                        return {
                            ...item,
                            spreadSpaceTypeTxt: txt?txt.label:''
                        }
                    });
                    that.setPage();
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
    }
}
</script>
<style scoped>
.ra-table {
    margin-top: 12px;
    margin-bottom: 22px;
}
</style>